import { render, staticRenderFns } from "./view_details_box.vue?vue&type=template&id=21ee8b76&scoped=true"
import script from "./view_details_box.vue?vue&type=script&lang=js"
export * from "./view_details_box.vue?vue&type=script&lang=js"
import style0 from "./view_details_box.vue?vue&type=style&index=0&id=21ee8b76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ee8b76",
  null
  
)

export default component.exports